import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const WaiverListDetails = ({ invoiceId }) => { 
  const [waivers, setWaivers] = useState([]); 
  
  useEffect(() => { 
    const fetchWaivers = async () => { 
      try {      
       
        var url =  `${API_DOMAIN}${API_ROUTES.waiver}?invoice_id=${invoiceId}`;       
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
  
        setWaivers(response.data); 
      } catch (error) { 
        console.error('Error fetching waivers:', error); 
      } 
    }; 
  
    fetchWaivers(); 
  }, [invoiceId]); 
  
  const columns = [ 
    { label: 'Amount', value: 'amount' }, 
    { label: 'Reason', value: 'reason' }, 
    { label: 'Approved Date', value: 'approved_date' }, 
    { label: 'Approved By', value: 'approved_by' }, 
    { label: 'Created At', value: 'created_at' }, 

  ]; 
  
  const handleViewDetails = (waiverId) => { 
    //console.log('View Details', waiverId);
    const encodedId = btoa(waiverId); 
    window.location.href = `/waiver/details/${encodedId}`; 
  }; 
  
  const actionButtons = [ 
    // { label: 'View Details', handler: handleViewDetails }, 
  ]; 
  
  return <ListTemplate columns={columns} data={waivers} actionButtons={actionButtons} />; 
}; 
  
export default WaiverListDetails;